import React from 'react'
import queryString from 'query-string'
import { Trans } from '@lingui/macro'

import { ButtonPrimary } from 'front-end/src/components'
import {
  FollowResourceType,
  WorkspaceModelAsCoordinator
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import IconRefresh from '../../components/common/icon/IconRefresh'
import TextElement from '../topic-detail-page/topic-elements/TextElement'
import TopicVersionTitleAndSummary from '../topic-detail-page/TopicVersionTitleAndSummary'
import { CommentsFooter } from '../../components/common/comments/comments-footer/CommentsFooter'
import { useScormPreviewQuery } from './ScormPagePreview.codegen'
import './ScormPagePreview.less'
import { TopicDetail } from '../topic-detail-page/TopicDetailContext'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export interface IScormPageProps {
  topic: TopicDetail
}

export const ScormPagePreview = (props: IScormPageProps) => {
  const { session } = usePublicApiSession()
  const { data } = useScormPreviewQuery({
    variables: {
      id: props.topic.workspace_id,
      topicId: props.topic.id,
      redirect: `${window.location.href.split('?')[0]}?previouslyopened=true`
    }
  })

  if (!data || !data.workspace) {
    return null
  }

  const { topicModelAsEditor } = data.workspace as WorkspaceModelAsCoordinator
  const qs = queryString.stringify({
    custom_1: session?.user.custom_1 || '',
    custom_2: session?.user.custom_2 || '',
    custom_3: session?.user.custom_3 || ''
  })

  return (
    <div className="PreviewScormPage">
      <div className="PreviewScormPage__inner">
        <div className="page page-system-generated-title">
          {
            <TopicVersionTitleAndSummary
              title={props.topic.draftVersion?.title}
              summary={props.topic.draftVersion?.summary}
            />
          }
        </div>
        {props.topic.draftVersion?.elements?.length === 1 && (
          <div
            className={`ql-editor page-content page-content-text element element-text element-mode-view`}
          >
            <TextElement
              content={
                props.topic?.draftVersion?.elements[0]?.data?.content as string
              }
            />
          </div>
        )}
        <div className="ScormPage__course">
          <ButtonPrimary
            size="lg"
            onClick={() =>
              window.open(
                `${topicModelAsEditor?.draftVersion?.scormCourse?.preview}&${qs}` ||
                  '',
                '_self'
              )
            }
            leftIcon={<IconRefresh />}
          >
            <Trans>Launch the course</Trans>
          </ButtonPrimary>
        </div>
      </div>
      <div className="Footer">
        <CommentsFooter
          itemType={FollowResourceType.topic}
          itemId={props.topic.id}
          allowComments={props.topic.allow_comments || false}
        />
      </div>
    </div>
  )
}
